
export const printColumnHeader = [
  {
    id: "No",
    name: "No",
    prompt: "No.",
    width: 0.4,
    align: "center",
    padding: 0,
    separateRow: "-"
  },
  {
    id: "ScInvNo",
    name: "ScInvNo",
    prompt: "เลขที่ใบแจ้งหนี้",
    width: 1.7,
    align: "center",
    padding: 0,
    separateRow: "-"
  },
  {
    id: "AptTm",
    name: "AptTm",
    prompt: "วันที่เข้า รง.",
    width: 1,
    align: "center",
    padding: 0,
    separateRow: "-"
  },
  {
    id: "Loc",
    name: "Loc",
    prompt: "สถานที่",
    width: 2.8,
    align: "center",
    padding: 0,
    separateRow: "#TEXT#"
  },
  {
    id: "ContNo",
    name: "ContNo",
    prompt: "หมายเลขตู้",
    width: 1.2,
    align: "center",
    padding: 0,
    separateRow: "-"
  },
  {
    id: "TrnsAmnt",
    name: "TrnsAmnt",
    prompt: "ค่าขนส่ง",
    width: 1,
    align: "right",
    padding: 0,
    separateRow: "#SUM#"
  },
  {
    id: "OwnRcptAmnt",
    name: "OwnRcptAmnt",
    prompt: "อื่นๆ",
    width: 0.8,
    align: "right",
    padding: 0,
    separateRow: "#SUM#"
  },
  {
    id: "CusRcptAmnt",
    name: "CusRcptAmnt",
    prompt: "คจ.ล่วงหน้า",
    width: 1,
    align: "right",
    padding: 0,
    separateRow: "#SUM#"
  },
]
